export const ADMIN = 'ADMIN';
export const SYS_ADMIN = 'SYSTEM ADMIN';
export const OPERATOR = 'OPERATOR';
export const SUPERVISOR = 'SUPERVISOR';
export const FOCUSED_OPERATOR = 'FOCUSED OPERATOR';
export const VIEWER = 'VIEWER';

export const QUEUES_ALLOWED_ROLES = [ADMIN, SYS_ADMIN, SUPERVISOR];
